import React, { useContext, useState, useEffect } from 'react'

const AppContext = React.createContext()

//:::: AUDIOBOOK PATH MATERIALS
//const API_ENDPOINT = 'https://www.dlc.pt/conteudosCursos/Metex/audiobook-data'
const API_ENDPOINT = 'https://www.davidpadua.com/projects/audiobook/'


const AppProvider = ({ children }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [audioList, setAudioList] = useState([]);
    const [backgroundColors, setBackgroundColors] = useState([]);

    // set list of background colors
    let listOfColors = []

    const getRandomColor = () => {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    const pushColorToArray = () => {
        listOfColors.push(getRandomColor())

    }
  

  

    // fetch and set final data
      useEffect(() => {
        async function fetchData() {
            try {
                const response = await fetch(`${API_ENDPOINT}/lista-vozOff-metex.json`);
                const json = await response.json();
                setAudioList(json.audios);//audios é a propriedade/palavra no json
                setIsLoading(false);
                // set an array of background color
                if(json.audios.length > 0) {
                    json.audios.forEach(pushColorToArray);
                    if(listOfColors.length === json.audios.length) {
                        setBackgroundColors(listOfColors)
                    }
                }
                
            } catch (e) {
                console.error(e);
            }
        };
        fetchData();
    }, []);


    return <AppContext.Provider value={{isLoading, audioList, backgroundColors, API_ENDPOINT}}>{children}</AppContext.Provider>
}

// make sure use
export const useGlobalContext = () => {
    return useContext(AppContext)
  }
  
  export { AppContext, AppProvider }
